<kendo-dialog [minWidth]="800" *ngIf="ruleTesterOpened" (close)="closeModal()">
    <kendo-dialog-titlebar>
        <h3>{{'RULE-TESTER' | translate}}</h3>
    </kendo-dialog-titlebar>
    <form [formGroup]="ruleTesterForm" class="k-form container-tester" style="margin-top:-10px;">
        <div>
            <div class="k-text-uppercase dark mb-2 font-weight-bold">{{'RULE-PREVIEW' | translate}}
                <span class="k-text-uppercase dark mb-2 font-weight-bold"> - {{ruleName}}
                </span>
            </div>
            <hr />
            <div class="row">
                <div class="col-10">
                    <pre class="narrative"><div [innerHTML]="queries | ruleNarrative: configs"></div></pre>
                </div>
                <div class="col-2 text-center" style="margin:auto;">
                    <i *ngIf="ruleMatched !== undefined && ruleMatched"
                        class="fas fa-check-circle fa-2x ruleset-matched" title="{{'RULE-TESTER-MATCHED' | translate}}">
                    </i>
                    <i *ngIf="ruleMatched !== undefined && !ruleMatched"
                        class="fas fa-times-circle fa-2x ruleset-not-matched"
                        title="{{'RULE-TESTER-NOT-MATCHED' | translate}}">
                    </i>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <label class="k-form-field">
                    <span class="k-text-uppercase dark font-weight-bold">
                        {{'XML-INPUT' | translate}} *
                    </span>
                    <div *ngIf="loading" class="text-center">
                        <span class="k-icon k-i-loading kendo-loading-icon"></span>
                    </div>
                    <textarea *ngIf="!loading" kendoTextArea class="w-100" style="font-family: monospace;" cols="120"
                        rows="6" formControlName="xml">
                    </textarea>
                    <div class="k-tooltip k-tooltip-validation" role="alert" *ngIf="xml.invalid && xml.touched">
                        {{'XML-REQUIRED' | translate}}
                    </div>
                </label>
            </div>
        </div>
        <div class="row pb-2">
            <div class="col-12">
                <label class="control-label pt-2" for="active">{{ 'SAVE' | translate }}
                    <kendo-switch formControlName="xmlSave" onLabel="{{'YES' | translate }}"
                        offLabel="{{'NO' | translate }}" class="ml-2">
                    </kendo-switch>
                    <span [hidden]="!ruleTesterForm.controls.xmlSave.value"
                        class="text-danger ml-2 text-uppercase font-weight-bold">{{ 'MUST-NOT-CONTAIN-PHI' | translate
                        }}</span>
                </label>
            </div>
        </div>
    </form>
    <div>* {{'REQUIRED-FIELDS' | translate}}</div>
    <kendo-dialog-actions>
        <button kendoButton type="button" [disabled]="!ruleTesterForm.valid" (click)="testRules()">
            {{ 'EXECUTE-TEST' | translate}}
        </button>
        <button kendoButton type="button" (click)="closeModal()">
            {{ 'CLOSE' | translate}}
        </button>
    </kendo-dialog-actions>
</kendo-dialog>